module.exports = __webpack_public_path__ + "img/favicon-logo.e5b3c05.png";